import { Stack } from '@mui/material';
import { ReactElement } from 'react';
import { InfoSectionProps, InfoSection } from './InfoSection';

type ChartWithTakeawaysProps = {
  takeaways: InfoSectionProps['takeaways'];
  recommendations: InfoSectionProps['recommendations'];
  editable: InfoSectionProps['editable'];
  children: ReactElement;
  onChange?: InfoSectionProps['onChange'];
};

export const ChartWithTakeaways = (props: ChartWithTakeawaysProps) => (
  <Stack direction="column" spacing={2}>
    {props.children}
    <InfoSection
      takeaways={props.takeaways}
      recommendations={props.recommendations}
      editable={props.editable}
      onChange={props.onChange}
    />
  </Stack>
);
